/// <amd-module name="Artifacts/Upack/helpers/InstructionsHelper" />
import { TfsServiceInstanceId } from "Artifacts/Root/Constants";
import { IFeed, IPackageVersion } from "Artifacts/Root/types";
import { IVssPageContext } from "VSS/Platform/Context";
import { getServiceLocation } from "VSS/Platform/Location";

export function getCopyInstallCommand(
  pageContext: IVssPageContext,
  feed: IFeed,
  pkgName: string,
  pkgVersion: IPackageVersion,
  separator = " ",
): string {
  const endpointUrl = getEndpointUrl(pageContext);
  const projectParam = feed.project
    ? `--project "${feed.project.id}"${separator}` + `--scope project${separator}`
    : "";
  return (
    `az artifacts universal download${separator}` +
    `--organization "${endpointUrl}"${separator}` +
    projectParam +
    `--feed "${feed.name}"${separator}` +
    `--name "${pkgName}"${separator}` +
    `--version "${pkgVersion.version}"${separator}` +
    "--path ."
  );
}

function getEndpointUrl(pageContext: IVssPageContext): string {
  return getServiceLocation(pageContext, TfsServiceInstanceId);
}
